import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BacktestFormState {
  symbol: string;
  strategy: string;
  timeframe: string;
  startDate: string;
  endDate: string;
  capital: string;
  stopLoss: string;
  takeProfit: string;
  gridSize: string;
  priceRange: string;
  orderQuantity: string;
  lotSize: string;
  updateInterval: string;
  minProfit: string;

  setSymbol: (v: string) => void;
  setStrategy: (v: string) => void;
  setTimeframe: (v: string) => void;
  setStartDate: (v: string) => void;
  setEndDate: (v: string) => void;
  setCapital: (v: string) => void;
  setStopLoss: (v: string) => void;
  setTakeProfit: (v: string) => void;
  setGridSize: (v: string) => void;
  setPriceRange: (v: string) => void;
  setOrderQuantity: (v: string) => void;
  setLotSize: (v: string) => void;
  setUpdateInterval: (v: string) => void;
  setMinProfit: (v: string) => void;
}

export const useBacktestStore = create<BacktestFormState>()(
  persist(
    (set) => ({
      symbol: '',
      strategy: 'grid_bot',
      timeframe: '1h',
      startDate: '2023-01-01',
      endDate: '2024-01-01',
      capital: '10000',
      stopLoss: '5',
      takeProfit: '10',
      gridSize: '10',
      priceRange: '5',
      orderQuantity: '1',
      lotSize: '1000',
      updateInterval: '60',
      minProfit: '0.5',

      setSymbol: (v) => set({ symbol: v }),
      setStrategy: (v) => set({ strategy: v }),
      setTimeframe: (v) => set({ timeframe: v }),
      setStartDate: (v) => set({ startDate: v }),
      setEndDate: (v) => set({ endDate: v }),
      setCapital: (v) => set({ capital: v }),
      setStopLoss: (v) => set({ stopLoss: v }),
      setTakeProfit: (v) => set({ takeProfit: v }),
      setGridSize: (v) => set({ gridSize: v }),
      setPriceRange: (v) => set({ priceRange: v }),
      setOrderQuantity: (v) => set({ orderQuantity: v }),
      setLotSize: (v) => set({ lotSize: v }),
      setUpdateInterval: (v) => set({ updateInterval: v }),
      setMinProfit: (v) => set({ minProfit: v }),
    }),
    {
      name: 'backtest-form-storage',
      partialize: (state) => ({
        symbol: state.symbol,
        strategy: state.strategy,
        timeframe: state.timeframe,
        startDate: state.startDate,
        endDate: state.endDate,
        capital: state.capital,
        stopLoss: state.stopLoss,
        takeProfit: state.takeProfit,
        gridSize: state.gridSize,
        priceRange: state.priceRange,
        orderQuantity: state.orderQuantity,
        lotSize: state.lotSize,
        updateInterval: state.updateInterval,
        minProfit: state.minProfit,
      }),
    }
  )
);
